import {
  WbBreadcrumb,
  WbBreadcrumbs,
  WbHeader,
  WbHeaderActions,
} from '@agilelab/plugin-wb-platform';
import {
  TaxonomySelector,
  useTaxonomySelection,
} from '@agilelab/plugin-wb-practice-shaper';
import { Content } from '@mainstage/core-components';
import { PrototypeTable } from './components/PrototypeTable';
import { WbPage } from '@agilelab/plugin-wb-platform';

export const PrototypeListPage = () => {
  const { shouldDisable } = useTaxonomySelection();

  return (
    <WbPage themeId="home">
      <WbHeader
        title="Backlog"
        breadcrumbs={
          <WbBreadcrumbs aria-label="breadcrumb">
            <WbBreadcrumb>Builder</WbBreadcrumb>
            <WbBreadcrumb>Backlog</WbBreadcrumb>
          </WbBreadcrumbs>
        }
        topbarActions={
          <WbHeaderActions>
            {!shouldDisable && <TaxonomySelector />}
          </WbHeaderActions>
        }
      />
      <Content>
        <PrototypeTable />
      </Content>
    </WbPage>
  );
};
